import { Pipe, PipeTransform } from '@angular/core';
import { filter } from 'rxjs/operators';

@Pipe({
  name: 'filterInteractive'
})
export class FilterMultimediaInteractivePipe implements PipeTransform {

  constructor() { }
  transform(array, isSm = false) {
      if( isSm != undefined ){
       return array.filter(e => e.isinteractive != isSm && e.isvideo != true);
      }
   return array.filter(e => e.isvideo != true);
  }

}
